import React from 'react';
import type { SwiperOptions } from 'swiper';
import SwiperCore, {
  Navigation,
  Scrollbar,
  Mousewheel,
  Pagination,
  Thumbs,
  Keyboard,
  FreeMode,
} from 'swiper';
import 'swiper/swiper-bundle.css';
import type { HotelPageGallerySwiperProps } from './types';
import { navigation } from './styles';

import GallerySwiper from './GallerySwiper';

SwiperCore.use([
  Navigation,
  Scrollbar,
  Mousewheel,
  Pagination,
  Thumbs,
  Keyboard,
  FreeMode,
]);

const HotelPageGallerySwiper = ({
  images,
  video,
  isMobile,
  title,
  hotelId,
}: HotelPageGallerySwiperProps) => {
  const defaultParams = {
    navigation,
    lazyPreloadPrevNext: 6,
    loop: images.length > 7,
  };
  const paramsSwiper: SwiperOptions = {
    slidesPerView: isMobile ? 1 : ('auto' as const),
    mousewheel: {
      forceToAxis: true,
    },
    freeMode: isMobile
      ? false
      : {
          enabled: true,
          sticky: false,
          momentumBounce: false,
        },
    slidesPerGroup: isMobile ? 1 : 3,
    speed: 600,
    pagination: isMobile
      ? {
          type: 'fraction',
        }
      : false,
    ...defaultParams,
  };
  const paramsSmallSwiper = {
    mousewheel: true,
    freeMode: {
      enabled: true,
      sticky: false,
      momentumBounce: false,
    },
    navigation,
  };
  return (
    <GallerySwiper
      images={images}
      video={video}
      isMobile={isMobile}
      title={title}
      hotelId={hotelId}
      paramsSmallSwiper={paramsSmallSwiper}
      paramsSwiper={paramsSwiper}
    />
  );
};

export default HotelPageGallerySwiper;
